var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpAvgpool2D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.458333 26.458334",
    height: 100,
    width: 100,
    id: "svg42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs46"
  })), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 0.0000064941405,
    x: -2.3455812e-7,
    height: 26.458334,
    width: 26.458334,
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect2"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 0.76186782,
    y: 19.462866,
    id: "rect4"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 0.76186782,
    y: 6.9956121,
    id: "rect20"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 13.229167,
    y: 0.76196939,
    id: "rect32"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.9956121,
    x: 6.9955168,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#bebebe",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect22"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.76196939,
    x: 0.76186782,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#d4d4d4",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.52916667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect28"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a9a9a9",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 6.9955168,
    y: 0.76196939,
    id: "rect30"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.9956121,
    x: 0.76186782,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect870"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.9956121,
    x: 13.229167,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a2a2a2",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect24"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 19.462816,
    y: 6.9956121,
    id: "rect26"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.76196939,
    x: 19.462816,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#c2c2c2",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect34"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.76196939,
    x: 13.229167,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#b7b7b7",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect872"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.462866,
    x: 13.229167,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect8"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#9e9e9e",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 19.462816,
    y: 19.462866,
    id: "rect10"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d7d7d7",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 13.229167,
    y: 13.229224,
    id: "rect16"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 19.462816,
    y: 13.229224,
    id: "rect874"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.462866,
    x: 6.9955168,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#d1d1d1",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect6"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.229224,
    x: 0.76186782,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#d1d1d1",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect12"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#c5c5c5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 6.9955168,
    y: 13.229224,
    id: "rect14"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.462866,
    x: 0.76186782,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#ababab",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect956"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.4,
    height: 25.400002,
    x: 0.52916694,
    y: 0.52915078,
    ry: 0,
    id: "rect36"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 12.677838,
    height: 25.400002,
    x: 13.251328,
    y: 0.52915078,
    ry: 0,
    id: "rect38"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.4,
    height: 12.720511,
    x: 0.52916694,
    y: 13.208642,
    ry: 0,
    id: "rect40"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 3.8787909,
    x: 16.345991,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#9b9b9b",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect958"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.346045,
    x: 16.345991,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#b1b1b1",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect984"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.346045,
    x: 3.8786924,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#c2c2c2",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect986"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 3.8787909,
    x: 3.8786924,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect988"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpAvgpool2D);
export default __webpack_public_path__ + "static/media/op-avgpool2d.58c93e0326ce4d02baab998575a79094.svg";
export { ForwardRef as ReactComponent };